import { Component } from '@angular/core';
import { NewsProvider } from '../../providers/news/news';

/**
 * Generated class for the NewsFeedsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'news-feeds',
  templateUrl: 'news-feeds.html'
})
export class NewsFeedsComponent {

  constructor(public newsCtrl: NewsProvider) {
  }

}



// WEBPACK FOOTER //
// ./src/components/news-feeds/news-feeds.ts